import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=66728b7c&scoped=true&lang=html&"
import script from "./Pages.vue?vue&type=script&lang=js&"
export * from "./Pages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66728b7c",
  null
  
)

export default component.exports